export const timeoutValue = 10000;

export const maxWidthXS = "375px";

export const breakpointMaxTinyDevice = `screen and (max-width: ${maxWidthXS})`;
export const breakpointMinTinyDevice = `screen and (min-width: ${maxWidthXS})`;

export const breakpointMaxMobile = `screen and (max-width: 768px)`;

export const breakpointMinMobile = `screen and (min-width: 768px)`;

export const breakpointMaxTablet = `screen and (max-width: 1024px)`;
export const breakpointMinTablet = `screen and (min-width: 1024px)`;

export const breakpointMinDesktop = `screen and (min-width: 80rem)`; // 80rem = 1280px

export const breakpointMinLargeDesktop = `screen and (min-width: 1440px)`;
